var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.model)?_c('div',[_c('v-text-field',{attrs:{"label":"Название","error-messages":_vm.errorsFor('name')},model:{value:(_vm.model.name),callback:function ($$v) {_vm.$set(_vm.model, "name", $$v)},expression:"model.name"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }